import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ɵConsole, DoCheck, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl } from '@angular/forms';
import { MessageService } from 'primeng/components/common/messageservice';
import { FinanceiroService } from '../financeiro.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../../fase/fase.service';
import { AuthService } from '../../admin/auth.service';
import { Usuario } from '../../../models/usuario';
import { Observable } from 'rxjs/Observable';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { Util } from '../../shared/util';
import { CandidatoService } from '../../candidato/candidato.service';
import { Candidato } from '../../../models/candidato';
import { CfcService } from '../../cfc/cfc.service';
import { ClinicaService } from '../../clinica/clinica.service';
import { LaboratorioService } from '../../laboratorio/laboratorio.service';
import { TipoFornecedor } from '../../../models/tipoFornecedor';
import { EditalCredenciamentoService } from '../../editalCredenciamento/edital-credenciamento.service';
import { Prestador } from '../../../models/prestador';
import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { TipoTransacao } from '../../../models/tipoTransacao';
declare var $: any;
@Component({
  selector: 'sispac-saida-form',
  templateUrl: './saida-form.component.html',
  styleUrls: ['./saida-form.component.css']
})
export class SaidaFormComponent extends WebPage implements OnInit, DoCheck, OnDestroy {

  @Input() recebeIdTipoTransacao;
  @Input() recebeTipoFornecedor;
  @Output() repostaFormulario = new EventEmitter();
  public recebeTipoFornecedorOld: any;
  public usuario: Usuario;
  public formSaida: FormGroup;
  public formCadFornecedor: FormGroup;
  public formFornecedor: FormGroup;
  public formAluno: FormGroup;
  public fases: any[];
  public tipoDespesas: any[];
  public contas: any[];
  public uploadUrl;
  public arquivosToRemove = new FormArray([]);
  public pesquisarAluno = false;
  public cpfPesquisar = '';
  public visible = 'block';
  public visibleAnimate = 1;
  public candidato: Candidato;
  public listaAlunos: any[] = [];
  public fornecedor: any;
  public listaLaboratorios: any[] = [];
  public listaFornecedores: any[] = [];
  public listaHistoricoFornecedores: any[];
  private formDados: any;
  public listaEditais: any[];
  public totalValorAluno = 0;
  public cnpjOuCpf: string;
  public idLancamento: any;
  public lancamento: any;
  public desabilitar = true;
  // @ViewChild('modalAluno') modalAluno: ElementRef;

  get cpf() { return this.formSaida.get('cpf'); }
  get arquivos() { return this.formSaida.get('arquivos') as FormArray; }
  get cnpjFornecedor() { return this.formFornecedor.get('cnpjFornecedor'); }
  get cpfFornecedor() { return this.formFornecedor.get('cpfFornecedor'); }

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private el: ElementRef,
    private _financeiroService: FinanceiroService,
    private _faseService: FaseService,
    private _unidadeService: UnidadeService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private _candidatoService: CandidatoService,
    private _cfcService: CfcService,
    private _clinicaService: ClinicaService,
    private _editalService: EditalCredenciamentoService,
    private _laboratorioService: LaboratorioService,
    private confirmationService: ConfirmationService,
    private _fornecedorService: FornecedorService) {
    super(messageService);
    this.buildForm();
    this.usuario = this.authService.informacoesUsuario();
    this.uploadUrl = this.arquivoService.uploadUrl + 'comprovanteDespesaLancamento';
    this.recebeTipoFornecedorOld = this.recebeTipoFornecedor;
    if (this.router.url.includes('visualizar')) {
      this.formSaida.disable();
      this.desabilitar = false;
    }

    this.route.paramMap.subscribe(params => {
      if (params.has('id')) {
        this.idLancamento = params.get('id');
      }
    });

  }

  ngOnInit() {
    console.log('desabilitar', this.desabilitar);
    this.getFasesIdUnidade();
    this.getContas();
    this.getTipoDespesas();

    if (this.idLancamento !== undefined && this.idLancamento !== null) {
      this.getLancamento();
    }
    console.log(this.formSaida.value);
  }

  buildForm() {
    this.formSaida = this.fb.group({
      idLancamento: [null],
      idControleLancamento: [null],
      idTipoTransacao: [null, [Validators.required]],
      idFase: [null, [Validators.required]],
      idEditalCredenciamento: [null],
      idConta: [null, [Validators.required]],
      idContaDestino: [null],
      dataLancamento: [null],
      descricao: [null],
      valor: [null, Validators.required],
      retencaoImposto: [null],
      idTipoDespesa: [null, Validators.required],
      idTipoFornecedor: [null, Validators.required],
      idUnidade: [null],
      idArquivoComprovanteDespesa: [null, Validators.required],
      numeroDocumento: [null, Validators.required],
      arquivos: new FormArray([]),
      cpf: [null],
      idUsuarioGestaoSS: null
    });

    this.formFornecedor = this.fb.group({
      idFornecedor: [null],
      tpFornecedor: [null, Validators.required],
      cpfFornecedor: [null],
      cnpjFornecedor: [null],
      idContrato: [null]
    });

    this.formAluno = this.fb.group({
      idLancamentoCandidato: [null],
      idCandidato: [null],
      cpfAluno: [null],
      nomeAluno: [null],
      valorDespesa: [null, Validators.required],
    });

    this.formCadFornecedor = this.fb.group({
      idLancamentoFornecedor: [null],
      idFornecedor: [null],
      cpf: [null],
      cnpj: [null],
      razaoSocial: [null, Validators.required],
      telefone: [null, Validators.required],
      endereco: [null, Validators.required],
      idUnidade: [null],
    });
  }

  getEditalCredenciamento(idFase) {
    if (idFase === '' || this.usuario.IdUnidade === '' || this.recebeTipoFornecedor === null) {
      this.listaEditais = [];
      return;
    }

    if (this.recebeTipoFornecedor.toUpperCase() === TipoFornecedor.CFC
      || this.recebeTipoFornecedor.toUpperCase() === TipoFornecedor.Clinica) {
      const idFornecedor = (this.recebeTipoFornecedor.toUpperCase() === TipoFornecedor.CFC ? Prestador.idCfc : Prestador.idClinica);
      this._editalService.getEditalByIdUnidadeAnIdFase(this.usuario.IdUnidade, idFase, idFornecedor)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {
            this.listaEditais = data;
          },
          error => {
            this.gerenciaErro(error);
          }
        );
    }
  }

  openModal(modal: string) {
    $(this.el.nativeElement.querySelector('#' + modal)).modal('show');
    // $(this.modalAluno.nativeElement).modal('show');
    // $(this.el.nativeElement.querySelector('#' + modal)).modal('hide');
  }

  closeModal(modal: string) {
    this.formAluno.reset();
    this.formFornecedor.reset();
    $(this.el.nativeElement.querySelector('#' + modal)).modal('hide');
  }
  getCandidatoByCpf() {
    if (this.formSaida.value.cpf !== null) {
      // let cpfAluno = this.formSaida.value.cpf;
      let cpfAluno = this.formSaida.value.cpf.replace(/(\.|\/|\-)/g, '');
      // console.log(this.listaAlunos);
      // console.log(this.listaAlunos.some(x => x.cpfAluno === cpfAluno));

      this._candidatoService.getFullUnidade(this.usuario.IdUnidade, cpfAluno,this.formSaida.value.idFase)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {

            if (data != null) {
              this.formSaida.patchValue({ cpf: null });
              this.candidato = data;

              if (this.candidato.possuiTermoAdesao) {
                console.log(data);
                this.openModal('modalAluno');
              } else {
                this.messageService
                  .add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: `O CPF informado ainda não possui termo de adesão.
                  Só é possível adicionar despesas para aluno que tenha o termo de adesão assinado e inserido no sistema.`
                  });
              }
            } else {
              this.candidato = null;
              this.messageService
                .add({
                  severity: 'warn',
                  summary: 'Atenção',
                  detail: 'O CPF informado não está participando do projeto nesta Unidade Operacional'
                });
            }
          },
          error => {
            this.gerenciaErro(error);
          }
        );
    }
  }

  getFasesIdUnidade() {
    this._faseService.getByUnidade(this.usuario.IdUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );
  }

  getContas() {
    this._financeiroService.getAllContas()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.contas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getTipoDespesas() {
    if (this.recebeTipoFornecedor === undefined) {
      this.tipoDespesas = [];
    } else {
      // this._financeiroService.getAllTipoDespesas()
      this._financeiroService.getAllByIdFornecedorUnidade(this.usuario.IdUnidade, this.recebeTipoFornecedor)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {
            this.tipoDespesas = data;
          },
          error => {
            this.gerenciaErro(error);
          }
        );
    }
  }

  getByUnidadeAndCnpj() {
    if ((this.cnpjFornecedor.value !== null || this.cpfFornecedor.value !== null)) {
      switch (this.recebeTipoFornecedor.toLocaleLowerCase()) {
        case TipoFornecedor.CFC.toLocaleLowerCase():

          this._cfcService.getByUnidadeAndCnpj(this.usuario.IdUnidade, Util.limpaCnpj(this.cnpjFornecedor.value))
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.fornecedor = data;
                // if (this.formFornecedor !== null) {
                if (this.fornecedor !== null) {
                  this.getByFornecedorHistorico();
                } else {
                  this.fornecedor = null;
                  this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Fornecedor não encontrado' });
                }
              },
              error => {
                this.gerenciaErro(error);
              }
            );

          break;

        case TipoFornecedor.Clinica.toLocaleLowerCase():
          this._clinicaService.getByUnidadeAndCnpj(this.usuario.IdUnidade, Util.limpaCnpj(this.cnpjFornecedor.value))
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.fornecedor = data;
                // if (this.formFornecedor !== null) {
                if (this.fornecedor !== null) {
                  this.getByFornecedorHistorico();
                } else {
                  this.fornecedor = null;
                  this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Fornecedor não encontrado' });
                }
              },
              error => {
                this.gerenciaErro(error);
              }
            );

          break;
        case TipoFornecedor.Laboratorio.toLocaleLowerCase():

          this._laboratorioService.getByUnidadeAndCnpj(this.usuario.IdUnidade, Util.limpaCnpj(this.cnpjFornecedor.value))
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                // console.log(data);
                this.listaLaboratorios = data;
                if (this.listaLaboratorios.length === 0) {
                  this.listaLaboratorios = [];
                  this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Fornecedor não encontrado' });
                }
              },
              error => {
                this.gerenciaErro(error);
              }
            );

          break;

        default:
          const valor = this.cnpjFornecedor.value == null ?
            Util.limpaCpf(this.cpfFornecedor.value) :
            Util.limpaCnpj(this.cnpjFornecedor.value);

          this._fornecedorService.getByCnpjOuCpf(this.usuario.IdUnidade, valor)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                // console.log(data);
                this.fornecedor = data;
                if (this.fornecedor == null) {
                  this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Fornecedor não encontrado' });
                }
              },
              error => {
                this.gerenciaErro(error);
              }
            );
          break;
      }
    }
  }

  mostrarDivNumeroProcesso(tipoFornecedor) {
    return tipoFornecedor === TipoFornecedor.CFC ||
      tipoFornecedor === TipoFornecedor.Clinica ||
      tipoFornecedor === TipoFornecedor.Laboratorio;
  }

  getByFornecedorHistorico() {
    switch (this.recebeTipoFornecedor.toLocaleLowerCase()) {
      case TipoFornecedor.CFC.toLocaleLowerCase():
        console.log(this.fornecedor);
        this._cfcService.getHistorico(this.fornecedor.idCfcUnidade)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              // console.log(data);
              this.listaHistoricoFornecedores = data;
            },
            error => {
              this.gerenciaErro(error);
            }
          );
        break;
      case TipoFornecedor.Clinica.toLocaleLowerCase():
        this._clinicaService.getHistorico(this.fornecedor.idClinicaUnidade)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              // console.log(data);
              this.listaHistoricoFornecedores = data;
            },
            error => {
              this.gerenciaErro(error);
            }
          );
        break;

      default:
        break;
    }
  }
  // ------
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;
    // console.log(idArquivo);
    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
    this.arquivosToRemove.push(arquivoFormGroup);
    this.formSaida.patchValue({ idArquivoComprovanteDespesa: idArquivo });
  }

  removeArquivo(arquivo: AbstractControl) {

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {

        // this.arquivosToRemove.push(arquivo);

        const index = this.arquivos.controls.indexOf(arquivo);
        this.arquivos.removeAt(index);

        let arquivosNovos: AbstractControl[];
        arquivosNovos = this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld);
        this.removeArquivosDoBanco(arquivosNovos);
      },
      reject: () => {
        // this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  downloadArquivo(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Documento_Laboratorio');
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.isLoading = true;
    // const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    const combined = arquivos.map(a => this._financeiroService.excluirComprovanteDespesa(a.value.idArquivo));
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = true)
      .subscribe(
        () => {
          // this.arquivosToRemove.reset();
          this.arquivosToRemove = new FormArray([]);
        },
        error => this.gerenciaErro(error)
      );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }
  // Arquivo
  // ------
  validaCpf() {
    if (!Util.isCpf(Util.limpaCpf(this.cpf.value))) {
      this.pesquisarAluno = false;
      this.messageService.add({ severity: 'error', summary: 'Atenção', detail: 'CPF inválido.' });
      this.cpf.setValue('');
    } else {
      this.pesquisarAluno = true;
    }
  }

  validaCpfForm(form: FormGroup, atributo: string) {
    if (!Util.isCpf(Util.limpaCpf(form.get(atributo).value))) {
      this.messageService.add({ severity: 'error', summary: 'Atenção', detail: 'CPF inválido.' });
      form.get(atributo).setValue(null);
    }
  }

  validaCnpj(cnpj) {
    if (!Util.isCnpj(Util.limpaCnpj(cnpj))) {
      this.messageService.add({ severity: 'error', summary: 'Atenção', detail: 'CNPJ inválido.' });
    }
  }

  validaCnpjForm(form: FormGroup, atributo: string) {
    // console.log(form);
    if (!Util.isCnpj(Util.limpaCnpj(form.get(atributo).value))) {
      this.messageService.add({ severity: 'error', summary: 'Atenção', detail: 'CNPJ inválido.' });
      form.get(atributo).setValue(null);
    }
  }

  submit() {
    // console.log('envia form filho');
    this.formSaida.patchValue({
      idTipoTransacao: this.recebeIdTipoTransacao,
      idTipoFornecedor: this.recebeTipoFornecedor,
      idUnidade: this.usuario.IdUnidade,
    });

    const dataLancamento = this.fomataData(this.formSaida.value.dataLancamento);
    const dataAtual = new Date();

    if (dataLancamento.getTime() > dataAtual.getTime()) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'O campo data e maior que a data atual!' });
      return;
    }

    // console.log(this.usuario);
    if (this.recebeTipoFornecedor === TipoFornecedor.Detran) {
      if (this.validaFormSubmit()) {
        this.submitDetran();
      }
    }else {
      if (this.validaFormSubmit()) {
        this.submitFornecedoresComum();
      }
    }
  }

  validaFormSubmit() {
    if (this.recebeTipoFornecedor !== TipoFornecedor.Detran) {
      // this.formSaida.controls['valor'].clearValidators();
      // this.formSaida.controls['valor'].updateValueAndValidity();
      this.removeValidatorProperty('valor');
    }

    if (this.recebeTipoFornecedor === TipoFornecedor.Aluno) {
      // this.formSaida.controls['numeroDocumento'].clearValidators();
      // this.formSaida.controls['numeroDocumento'].updateValueAndValidity();
      this.removeValidatorProperty('numeroDocumento');

    }

    if (this.recebeTipoFornecedor === TipoFornecedor.Outros) {
      // this.formSaida.controls['idArquivoComprovanteDespesa'].clearValidators();
      // this.formSaida.controls['idArquivoComprovanteDespesa'].updateValueAndValidity();
      this.removeValidatorProperty('idArquivoComprovanteDespesa');
    }

    console.log(this.formSaida);
    let retorno = true;

    if (!this.formSaida.valid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campos obrigatórios não preenchidos!' });
      retorno = false;
    }

    if (this.recebeTipoFornecedor !== TipoFornecedor.Outros && this.arquivos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Arquivo não inserido!' });
      retorno = false;
    }

    if (this.recebeTipoFornecedor !== TipoFornecedor.Outros && this.listaAlunos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Aluno não informado!' });
      retorno = false;
    }

    if (this.recebeTipoFornecedor !== TipoFornecedor.Detran && this.recebeTipoFornecedor !== TipoFornecedor.Outros && this.listaFornecedores.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Fornecedor não informado!' });
      retorno = false;
    }
    return retorno;
  }

  submitDetran() {
    this.formDados = {
      idLancamento: this.formSaida.value.idLancamento,
      idControleLancamento: this.formSaida.value.idControleLancamento,
      idTipoTransacao: this.formSaida.value.idTipoTransacao,
      idFase: this.formSaida.value.idFase,
      idEditalCredenciamento: null,
      idConta: this.formSaida.value.idConta,
      idContaDestino: this.formSaida.value.idContaDestino,
      dataLancamento: this.formSaida.value.dataLancamento,
      descricao: this.formSaida.value.descricao,
      valor: this.formSaida.value.valor,
      retencaoImposto: this.formSaida.value.retencaoImposto,
      idTipoDespesa: this.formSaida.value.idTipoDespesa,
      idTipoFornecedor: this.formSaida.value.idTipoFornecedor,
      idUnidade: this.formSaida.value.idUnidade,
      idArquivoComprovanteDespesa: this.formSaida.value.idArquivoComprovanteDespesa,
      numeroDocumento: this.formSaida.value.numeroDocumento,
      idUsuarioGestaoSS: this.usuario.IdUsuario,
      lancamentoCandidato: [] = []
    };

    this.listaAlunos.forEach(x => {
      let listObj = { idCandidato: x.idCandidato, valor: x.valorDespesa };
      this.formDados.lancamentoCandidato.push(listObj);
    });
    // console.log(this.formDados);
    // this.repostaFormulario.emit(this.formDados);
    this.salvarDadosSubmit(this.formDados);

  }

  submitFornecedoresComum() {
    this.formDados = {
      idLancamento: this.formSaida.value.idLancamento,
      idControleLancamento: this.formSaida.value.idControleLancamento,
      idTipoTransacao: this.formSaida.value.idTipoTransacao,
      idFase: this.formSaida.value.idFase,
      idEditalCredenciamento: this.formSaida.value.idEditalCredenciamento,
      idConta: this.formSaida.value.idConta,
      idContaDestino: this.formSaida.value.idContaDestino,
      dataLancamento: this.formSaida.value.dataLancamento,
      descricao: this.formSaida.value.descricao,
      valor: 0,
      // valor: this.formSaida.value.valor,
      // valor: (this.totalValorAluno - this.formSaida.value.retencaoImposto),
      retencaoImposto: this.formSaida.value.retencaoImposto,
      idTipoDespesa: this.formSaida.value.idTipoDespesa,
      idTipoFornecedor: this.formSaida.value.idTipoFornecedor,
      idUnidade: this.formSaida.value.idUnidade,
      idArquivoComprovanteDespesa: this.formSaida.value.idArquivoComprovanteDespesa,
      numeroDocumento: this.formSaida.value.numeroDocumento,
      idUsuarioGestaoSS: this.usuario.IdUsuario,
      lancamentoCandidato: [] = []
    };

    if (this.recebeTipoFornecedor.toUpperCase() === TipoFornecedor.Outros) {
      this.formDados.valor = this.formSaida.value.valor;
    } else {
      //nova implementacao
      this.formDados.valor = (this.totalValorAluno - ((this.totalValorAluno/100) * this.formSaida.value.retencaoImposto));
    }

    this.listaAlunos.forEach(x => {
      const listObj = { idCandidato: x.idCandidato, valor: x.valorDespesa };
      this.formDados.lancamentoCandidato.push(listObj);
    });

    if (this.recebeTipoFornecedor === TipoFornecedor.CFC) {
      this.formDados.lancamentoFornecedor = {
        idCfcUnidadeHistorico: this.listaFornecedores[0].idCfcUnidadeHistorico
      };
    } else if (this.recebeTipoFornecedor === TipoFornecedor.Clinica) {
      this.formDados.lancamentoFornecedor = {
        idClinicaUnidadeHistorico: this.listaFornecedores[0].idClinicaUnidadeHistorico
      };
    } else if (this.recebeTipoFornecedor === TipoFornecedor.Laboratorio) {
      this.formDados.lancamentoFornecedor = {
        idLaboratorio: this.listaFornecedores[0].idLaboratorio
      };
    } else { }

    // console.log(this.listaFornecedores);
    // console.log(this.formDados);

    if (this.recebeTipoFornecedor !== TipoFornecedor.CFC
      && this.recebeTipoFornecedor !== TipoFornecedor.Clinica) {
      this.formDados.idEditalCredenciamento = null;
    }
    // this.repostaFormulario.emit(this.formDados);
    this.salvarDadosSubmit(this.formDados);
  }

  salvarDadosSubmit(form) {
    this.isLoading = true;
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja salvar este registro?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        // console.log(this.form.value);
        this._financeiroService.cadastrarEditarLancamento(form)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              if (this.idLancamento !== null && this.idLancamento !== undefined) {
                this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Cadastro salvo com sucesso!' });
                this.router.navigate(['/visualizar-prestacao-conta', this.lancamento.idControleLancamento]);
              } else {
                if (data === 'NAO_E_POSSIVEL_LANCAR_DESPESA') {
                  this.messageService.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    // tslint:disable-next-line: max-line-length
                    detail: 'Não é possível lançar despesas para o mês selecionados, pois a prestação de contas está em análise e aprovação!' });
                }else if (data === 'ANO_INVALIDO') {
                  this.messageService.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Não é possivel informar uma data com ano inferior que 2018!' });
                }else {
                  this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Cadastro salvo com sucesso!' });
                  this.formSaida.reset();
                  this.formAluno.reset();
                  this.formCadFornecedor.reset();
                  this.formFornecedor.reset();
                  this.listaAlunos = [];
                  this.listaFornecedores = [];
                  this.arquivos.removeAt(0);
                  this.arquivosToRemove = new FormArray([]);
                  this.calcularValorTotalAluno();
                }
              }
            },
            error => {
              this.isLoading = false;
              this.gerenciaErro(error);
            }
          );
      },
      reject: () => {
        this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  salvarLancamentoFornecedor() {
    if ((this.fornecedor !== null && this.fornecedor !== undefined) || (this.listaLaboratorios.length > 0)) {
      let forn: any;
      this.isLoading = true;
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja salvar este registro?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          switch (this.recebeTipoFornecedor) {
            case TipoFornecedor.CFC:
              forn = {
                idLancamentoFornecedor: null,
                nome: this.fornecedor.cfc.razaoSocial,
                cnpj: this.formFornecedor.value.cnpjFornecedor,
                idCfcUnidadeHistorico: this.formFornecedor.value.idContrato,
                numeroProcesso: this.listaHistoricoFornecedores
                  .filter(x => x.idCfcUnidadeHistorico === this.formFornecedor.value.idContrato)[0].numeroProcesso
              };
              break;
            case TipoFornecedor.Clinica:
              forn = {
                idLancamentoFornecedor: null,
                nome: this.fornecedor.clinica.razaoSocial,
                cnpj: this.formFornecedor.value.cnpjFornecedor,
                idClinicaUnidadeHistorico: this.formFornecedor.value.idContrato,
                numeroProcesso: this.listaHistoricoFornecedores
                  .filter(x => x.idClinicaUnidadeHistorico === this.formFornecedor.value.idContrato)[0].numeroProcesso
              };
              break;
            case TipoFornecedor.Laboratorio:
              forn = {
                idLancamentoFornecedor: null,
                nome: this.listaLaboratorios[0].razaoSocial,
                cnpj: this.formFornecedor.value.cnpjFornecedor,
                idLaboratorio: this.formFornecedor.value.idContrato,
                numeroProcesso: this.listaLaboratorios
                  .filter(x => x.idLaboratorio === this.formFornecedor.value.idContrato)[0].numeroProcessoCompra
              };
              break;
            default:
              forn = {
                idLancamentoFornecedor: null,
                nome: this.fornecedor.razaoSocial,
                cnpj: this.fornecedor.cnpj !== null ? this.fornecedor.cnpj : this.fornecedor.cpf,
                // cpf: this.fornecedor.cpf,
                idFornecedor: this.fornecedor.idFornecedor,
                numeroProcesso: ''
              };
              break;
          }
          // console.log(forn);
          this.listaFornecedores.push(forn);
          this.closeModal('modalFornecedor');
        },
        reject: () => {
          this.isLoading = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });
    } else {

    }
  }

  excluirFornecedor(cnpj) {

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        if (this.idLancamento !== null) {
          const fornecedor = this.listaFornecedores.find(x => x.cnpj === cnpj);
          console.log(fornecedor);
          if (fornecedor.idLancamentoFornecedor !== null) {
            this.excluirFornecedorBanco(fornecedor.idLancamentoFornecedor);
          }
        }
        this.listaFornecedores = this.listaFornecedores.filter(x => x.cnpj !== cnpj);
        this.fornecedor = null;
        this.listaLaboratorios = [];
      },
      reject: () => {
        // this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  salvarAluno() {
    this.formAluno.patchValue({
      idCandidato: this.candidato.idCandidato,
      nomeAluno: this.candidato.nome,
      cpfAluno: this.candidato.cpf
    });
    if (this.formAluno.valid) {
      this.listaAlunos.push(this.formAluno.value);
      // this.lancamentoCandidato.push(this.formAluno.value);
      if (this.recebeTipoFornecedor.toUpperCase() !== TipoFornecedor.Outros) {
        this.calcularValorTotalAluno();
      }
      this.closeModal('modalAluno');
    }
  }

  excluirAluno(cpf) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        if (this.idLancamento !== null) {
          const aluno = this.listaAlunos.find(x => x.cpfAluno === cpf);
          if (aluno.idLancamentoCandidato !== null) {
            this.excluirAlunoBanco(aluno.idLancamentoCandidato);
          }
        }
        this.listaAlunos = this.listaAlunos.filter(x => x.cpfAluno !== cpf);
        this.calcularValorTotalAluno();
      },
      reject: () => {
        // this.isLoading = false;
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });

  }

  calcularValorTotalAluno() {
    this.totalValorAluno = 0;
    this.listaAlunos.forEach(x => {
      this.totalValorAluno += x.valorDespesa;
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        if (this.idLancamento !== null && this.idLancamento !== undefined) {
          this.router.navigate(['/visualizar-prestacao-conta', this.lancamento.idControleLancamento]);
        } else {
          let arquivosNovos: AbstractControl[];
          arquivosNovos = this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld);
          if (this.arquivosToRemove.controls.length > 0) {
            this.removeArquivosDoBanco(arquivosNovos);
            // this.removeArquivosDoBanco();
          }
          this.router.navigate(['/gerenciar-prestacao-conta']);
        }
      }
    });
  }

  verificaBotaoPesquisarAluno(tpFornecedor: string) {
    return ((
      tpFornecedor.toUpperCase() === TipoFornecedor.Detran
      || tpFornecedor.toUpperCase() === TipoFornecedor.Aluno
      || tpFornecedor.toUpperCase() === TipoFornecedor.Outros
    )
      && this.listaAlunos.length === 0
    )
      ||
      (
        tpFornecedor.toUpperCase() !== TipoFornecedor.Detran
        && tpFornecedor.toUpperCase() !== TipoFornecedor.Aluno
        && tpFornecedor.toUpperCase() !== TipoFornecedor.Outros
      );
  }

  cadastrarFornecedor() {
    console.log(this.formCadFornecedor.value);

    if (this.cnpjOuCpf === 'pj') {
      if (!Util.isCnpj(Util.limpaCnpj(this.formCadFornecedor.value.cnpj))) {
        this.messageService.add({ severity: 'error', summary: 'Atenção', detail: 'CNPJ inválido.' });

        this.formCadFornecedor.controls['cpf'].clearValidators();
        this.formCadFornecedor.controls['cnpj'].setValidators(Validators.required);
        this.formCadFornecedor.controls['cpf'].updateValueAndValidity();
        this.formCadFornecedor.controls['cnpj'].updateValueAndValidity();

      }
    } else {
      if (!Util.isCpf(Util.limpaCpf(this.formCadFornecedor.value.cpf))) {
        this.messageService.add({ severity: 'error', summary: 'Atenção', detail: 'CPF inválido.' });

        this.formCadFornecedor.controls['cnpj'].clearValidators();
        this.formCadFornecedor.controls['cpf'].setValidators(Validators.required);
        this.formCadFornecedor.controls['cpf'].updateValueAndValidity();
        this.formCadFornecedor.controls['cnpj'].updateValueAndValidity();
      }
    }

    this.formCadFornecedor.patchValue({ idUnidade: this.usuario.IdUnidade });

    if (this.formCadFornecedor.valid) {
      const valor = this.formCadFornecedor.get('cnpj').value == null ?
        Util.limpaCpf(this.formCadFornecedor.get('cpf').value) :
        Util.limpaCnpj(this.formCadFornecedor.get('cnpj').value);

      this._fornecedorService.getByCnpjOuCpf(this.usuario.IdUnidade, valor)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {
            if (data == null) {
              this.submitCadFornecedor();
            } else {
              this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Fornecedor já cadastrado!' });
            }
          },
          error => {
            this.gerenciaErro(error);
          }
        );
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campos obrigatórios não preenchido!' });
    }
  }

  submitCadFornecedor() {
    this.confirmationService.confirm({
      message: 'Deseja mesmo salvar este registro?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this._fornecedorService.cadastrarEditar(this.formCadFornecedor.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            data => {
              this.closeModalCadFornecedor();
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        // this.isLoading = false;
        // this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  setValidatorProperty(propiedade: string, validator) {
    this.formSaida.controls[propiedade].setValidators(validator);
    this.formSaida.controls[propiedade].updateValueAndValidity();
  }

  removeValidatorProperty(propiedade: string) {
    this.formSaida.controls[propiedade].clearValidators();
    this.formSaida.controls[propiedade].updateValueAndValidity();
  }

  openModalCadFornecedor(cnpjOuCpf) {
    this.formCadFornecedor.reset();
    this.cnpjOuCpf = cnpjOuCpf;
    this.closeModal('modalFornecedor');
    this.openModal('modalCadFornecedor');
  }

  closeModalCadFornecedor() {
    this.closeModal('modalCadFornecedor');
    this.openModal('modalFornecedor');
    this.cnpjOuCpf = '';
  }

  cancelarModalCadFornecedor() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.closeModalCadFornecedor();
      },
      reject: () => {
        // this.isLoading = false;
        // this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  modalFornecedor() {
    this.listaLaboratorios = [];
    this.formFornecedor.reset();
    this.openModal('modalFornecedor');
  }

  closeModalFornecedor(modal) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.closeModal(modal);
      },
      reject: () => {
        // this.isLoading = false;
        // this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  ngDoCheck() {
    // console.log('Aqui');
    if (this.recebeTipoFornecedorOld !== this.recebeTipoFornecedor) {

      this.listaAlunos = [];
      this.recebeTipoFornecedorOld = this.recebeTipoFornecedor;
      this.getTipoDespesas();
      // disable this line to see the counter not moving
      // this._changeRef.detectChanges();
    }
  }

  ngOnDestroy() {
    // if (this.idLancamento !== null && this.idLancamento !== undefined) {
    //   if (this.arquivosToRemove.controls.length > 0) {
    //     let arquivosNovos: AbstractControl[];
    //     arquivosNovos = this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld);
    //     this.removeArquivosDoBanco(arquivosNovos);
    //   }
    // }
  }

  getLancamento() {
    // this._financeiroService.getByIdLancamento(this.idLancamento)
    this._financeiroService.getLancamentoSimplificado(this.idLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.lancamento = data;
          console.log(this.lancamento);
          if (this.lancamento !== null) {
            this.getEditalCredenciamento(this.lancamento.idFase);
            this.setValuesForm();
          }
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  setValuesForm() {
    this.formSaida.patchValue({
      idLancamento: this.lancamento.idLancamento,
      idControleLancamento: this.lancamento.idControleLancamento,
      idTipoTransacao: this.lancamento.idTipoTransacao,
      idFase: this.lancamento.idFase,
      idEditalCredenciamento: this.lancamento.idEditalCredenciamento,
      idConta: this.lancamento.idConta,
      idContaDestino: this.lancamento.idContaDestino,
      dataLancamento: this.lancamento.dataLancamento.split('T')[0],
      descricao: this.lancamento.descricao,
      valor: this.lancamento.valor,
      retencaoImposto: this.lancamento.retencaoImposto,
      idTipoDespesa: this.lancamento.idTipoDespesa,
      idTipoFornecedor: this.lancamento.idTipoFornecedor,
      idUnidade: this.lancamento.idUnidade,
      numeroDocumento: this.lancamento.numeroDocumento,
      idArquivoComprovanteDespesa: this.lancamento.idArquivoComprovanteDespesa,
    });
    this.setValuesFornecedor();
    this.setValuesAlunos();

    if (this.lancamento.arquivo !== null) {
      this.adicionaArquivo(this.lancamento.arquivo.idArquivo, this.lancamento.arquivo.nome, false);
    }
  }

  setValuesFornecedor() {
    if (this.lancamento.lancamentoFornecedor !== null) {
      let forn: any;
      if (this.lancamento.lancamentoFornecedor.idCfcUnidadeHistorico !== null) {
        forn = {
          idLancamentoFornecedor: this.lancamento.lancamentoFornecedor.idLancamentoFornecedor,
          nome: this.lancamento.lancamentoFornecedor.razaoSocial,
          cnpj: this.lancamento.lancamentoFornecedor.cnpjOuCpf,
          idCfcUnidadeHistorico: this.lancamento.lancamentoFornecedor.idCfcUnidadeHistorico,
          numeroProcesso: this.lancamento.lancamentoFornecedor.numeroProcesso
        };
      } else if (this.lancamento.lancamentoFornecedor.idClinicaUnidadeHistorico !== null) {
        forn = {
          idLancamentoFornecedor: this.lancamento.lancamentoFornecedor.idLancamentoFornecedor,
          nome: this.lancamento.lancamentoFornecedor.razaoSocial,
          cnpj: this.lancamento.lancamentoFornecedor.cnpjOuCpf,
          idClinicaUnidadeHistorico: this.lancamento.lancamentoFornecedor.idClinicaUnidadeHistorico,
          numeroProcesso: this.lancamento.lancamentoFornecedor.numeroProcesso
        };
      } else if (this.lancamento.lancamentoFornecedor.idLaboratorio !== null) {
        // console.log(this.lancamento.lancamentoFornecedor);
        forn = {
          idLancamentoFornecedor: this.lancamento.lancamentoFornecedor.idLancamentoFornecedor,
          nome: this.lancamento.lancamentoFornecedor.razaoSocial,
          cnpj: this.lancamento.lancamentoFornecedor.cnpjOuCpf,
          idLaboratorio: this.lancamento.lancamentoFornecedor.idLaboratorio,
          numeroProcesso: this.lancamento.lancamentoFornecedor.numeroProcesso
        };
      } else {
        forn = {
          idLancamentoFornecedor: this.lancamento.lancamentoFornecedor.idLancamentoFornecedor,
          nome: this.lancamento.lancamentoFornecedor.razaoSocial,
          cnpj: this.lancamento.lancamentoFornecedor.cnpjOuCpf,
          idFornecedor: this.lancamento.lancamentoFornecedor.idFornecedor,
          numeroProcesso: ''
        };
      }
      this.listaFornecedores.push(forn);
    }
  }

  setValuesAlunos() {
    this.lancamento.lancamentoCandidato.forEach(x => {
      const aluno = {
        idLancamentoCandidato: x.idLancamentoCandidato,
        idCandidato: x.idCandidato,
        nomeAluno: x.nome,
        cpfAluno: x.cpf,
        valorDespesa: x.valor
      };
      this.listaAlunos.push(aluno);
    });
    this.calcularValorTotalAluno();
  }

  excluirAlunoBanco(id) {
    this._financeiroService.excluirLancamentoCandidato(id)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  excluirFornecedorBanco(id) {
    this._financeiroService.excluirLancamentoFornecedor(id)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );

  }

  private fomataData(data) {
    return new Date(data.split('-')[0], (data.split('-')[1] - 1), data.split('-')[2], 0, 0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/saida-form/saida-form.component.ts